export function layawayMoney(value) {
	const amount = Number(value);
	return Number.isFinite(amount) ? amount : 0;
}

/** Customer credit / cash still owed when remaining is negative. */
export function layawayRefundDue(remaining) {
	const rem = layawayMoney(remaining);
	return rem < -0.005 ? Math.round(Math.abs(rem) * 100) / 100 : 0;
}

export function layawayPaidTowardContract(contractAmount, contractRemaining) {
	return layawayMoney(contractAmount) - layawayMoney(contractRemaining);
}

export function layawayWouldOverpayAfterChange(previewContractAmount, contractAmount, contractRemaining) {
	const paid = layawayPaidTowardContract(contractAmount, contractRemaining);
	return layawayMoney(previewContractAmount) - paid < -0.005;
}

/** Total customer refund due after a contract change (paid toward contract minus new total). */
export function layawayTotalRefundDueAfterChange(previewContractAmount, contractAmount, contractRemaining) {
	const paid = layawayPaidTowardContract(contractAmount, contractRemaining);
	return Math.max(0, Math.round((paid - layawayMoney(previewContractAmount)) * 100) / 100);
}

/** Additional refund from this change only — excludes credit already on the layaway. */
export function layawayOverpaymentCredit(previewContractAmount, contractAmount, contractRemaining) {
	const totalAfter = layawayTotalRefundDueAfterChange(previewContractAmount, contractAmount, contractRemaining);
	const existing = layawayRefundDue(contractRemaining);
	return Math.max(0, Math.round((totalAfter - existing) * 100) / 100);
}

export function formatLayawayMoney(amount) {
	return layawayMoney(amount).toFixed(2);
}

/**
 * @returns {number|null} signed difference (selected cash back minus refund due), or null when aligned / no refund due
 */
export function layawayRefundDueMismatch(refundDue, cashBackSelected, tolerance = 0.01) {
	if (layawayMoney(refundDue) < 0.005) {
		return null;
	}
	const diff = Math.round((layawayMoney(cashBackSelected) - layawayMoney(refundDue)) * 100) / 100;
	if (Math.abs(diff) <= tolerance) {
		return null;
	}
	return diff;
}
